<template>
  <div class="hall-seat"
       :class="{'reserved' : !isFree, 'selected': checkIsSelected}"
       :style="'grid-row:' + row + '; grid-column:' + col + ';'"
       @click="onSelectSeat">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'HallSeat',
  props: [ 'col', 'row', 'seatId', 'isFree', 'type' ],
  computed: {
    checkIsSelected () {
      return this.$store.state.selectedSeatSet.has(this.seatId)
    }
  },
  methods: {
    onSelectSeat () {
      if (this.isFree) {
        this.$store.dispatch('selectSeat', this.seatId)
      }
    }
  }
}
</script>

<style scoped>
.hall-seat {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #252525;
  color: #FFF;
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  cursor: pointer;
  transition: .2s;
  user-select: none;
  width: 50px;
  border-radius: 8px;
}

.hall-seat:nth-child(n+75) {
  position: absolute;
  width: 76.5px;
  height: 50px;
  left: -13px;
  border-radius: 10px;
}

.hall-seat.reserved:hover {
  background-color: #D0D5DD;
  transition: .2s;
}

.reserved {
  background-color: #D0D5DD;
  transition: .2s;
  cursor: default;
}

.hall-seat.selected {
  background-color: var(--beel-primary);
  transition: .2s;
}
</style>



// WEBPACK FOOTER //
// src/components/client/Seats/HallSeat.vue